module.exports = __webpack_public_path__ + "static/cartao-106af3baabb276a12e48b184e991621f.jpg";